module.exports = __webpack_public_path__ + "static/media/phone-cash.b026054c.svg";